import { Filtro } from './filtro';

export class FiltrosPesquisa
{
    produtos: Array<Filtro>;
    ufs: Array<Filtro>;
    cidades: Array<Filtro>;
    bairros: Array<Filtro>;
    areasAtuacao: Array<Filtro>;
    planos: Array<Filtro>;

    constructor()
    {
        this.produtos = new  Array<Filtro>();
        this.ufs = new Array<Filtro>();
        this.cidades = new Array<Filtro>();
        this.bairros = new Array<Filtro>();
        this.areasAtuacao = new Array<Filtro>();
        this.planos = new Array<Filtro>();
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/filtros-pesquisa.ts
 **/